<div>
  <!-- Dynamic Header Action & Catalog Filtering Controls Toolbar Section -->
  <header
    class="d-flex flex-wrap align-items-center justify-content-between gap-3 p-3 rounded-4 border shadow-sm bg-body-tertiary">
    <!-- Left Side: Ingestion Trigger Command Button -->
    <div class="d-flex align-items-center gap-2">
      @if (isAddNewUpdateAccess) {
      <button type="button"
        class="btn btn-sm btn-primary d-inline-flex align-items-center gap-1.5 px-3 py-2 shadow-sm fw-semibold"
        data-bs-toggle="modal" data-bs-target="#addNew">
        <i class="fa-solid fa-plus font-xs"></i>
        <span>Add New Item</span>
      </button>
      }
    </div>

    <!-- Right Side: Segmented Radio Filtering Control Matrix Group Toggle -->
    <div class="d-flex align-items-center gap-2">
      <div class="btn-group shadow-sm bg-body rounded border p-0.5" role="group"
        aria-label="Catalog Filtering Layout Toggles">
        <input type="radio" class="btn-check" name="catalogScope" id="scopeDefault" checked (change)="listAll()" />
        <label class="btn btn-sm btn-outline-primary px-3 fw-bold font-monospace text-uppercase border-0 rounded"
          for="scopeDefault">Default</label>

        <input type="radio" class="btn-check" name="catalogScope" id="scopeEnabled" (change)="ListAllEnabledRedeem()" />
        <label class="btn btn-sm btn-outline-primary px-3 fw-bold font-monospace text-uppercase border-0 rounded"
          for="scopeEnabled">Enabled</label>
      </div>
    </div>
  </header>

  <!-- Premium Ledger Data Grid Base Card Frame Box Wrapper -->
  <div class="card border shadow-sm rounded-4 overflow-hidden w-100 mt-3 bg-body">
    <div class="table-responsive m-0">
      <table class="table table-hover align-middle mb-0 text-nowrap">
        <!-- Table Header Matrix Layout -->
        <thead class="table-light text-body-secondary border-bottom font-monospace small text-uppercase tracking-wider">
          <tr>
            <th scope="col" class="ps-4 py-3" width="70">No</th>
            <th scope="col" class="py-3" style="min-width: 160px">Name</th>
            <th scope="col" class="py-3 text-end" width="110">Points</th>
            <th scope="col" class="py-3 text-end" width="130">MMK Value</th>
            <th scope="col" class="py-3">Service Name</th>
            <th scope="col" class="py-3 text-end" width="120">Minutes Value</th>
            <th scope="col" class="py-3">Redeemable Type</th>
            <th scope="col" class="py-3 text-center" width="120">Status</th>
            <th scope="col" class="pe-4 py-3 text-end font-monospace fw-bold text-primary-emphasis" width="160">
              Total:
            </th>
          </tr>
        </thead>

        <!-- Table Body Multi-Row Operations Logic Loop Frame -->
        <tbody class="small text-body">
          @for (
          data of results()
          | paginate
          : {
          itemsPerPage: pageSize(),
          currentPage: page(),
          totalItems: allTotal(),
          };
          track $index
          ) {
          <tr class="transition-base">
            <td class="ps-4 font-monospace fw-medium text-body-secondary">
              {{ data.srNo }}
            </td>

            <td class="fw-bold">{{ data.name }}</td>
            <td class="font-monospace text-end fw-medium">{{ data.points | number }}</td>
            <td class="font-monospace text-end fw-bold text-success-emphasis">
              {{ data.mmkValue | number }}
            </td>

            <td>
              <span
                class="badge bg-body-secondary text-body-secondary border border-secondary-subtle px-2.5 py-1 shadow-sm font-monospace fw-semibold">
                {{ data.serviceName }}
              </span>
            </td>

            <td class="font-monospace text-end text-body-secondary">
              {{ data.minutesValue ? (data.minutesValue | number) : '-' }}
            </td>

            <td class="text-uppercase font-monospace text-body-secondary font-xs">
              {{ data.redeemableType.replace('_', ' ') }}
            </td>

            <!-- Semantic Badged Condition Layout Matrix Indicators Mapping -->
            <td class="text-center">
              @if (data.enabled) {
              <span
                class="badge bg-success-subtle text-success-emphasis border border-success-subtle px-2.5 py-1.5 rounded-pill d-inline-flex align-items-center gap-1 font-xs">
                <i class="fa-solid fa-circle-check"></i> Enabled
              </span>
              } @else {
              <span
                class="badge bg-danger-subtle text-danger-emphasis border border-danger-subtle px-2.5 py-1.5 rounded-pill d-inline-flex align-items-center gap-1 font-xs">
                <i class="fa-solid fa-circle-xmark"></i> Disabled
              </span>
              }
            </td>

            <!-- Direct Command Interface Buttons Trigger Row Interaction Blocks -->
            <td class="pe-4 text-end">
              @if (isAddNewUpdateAccess) {
              <div class="d-inline-flex align-items-center justify-content-end gap-1.5 w-100">
                @if (!data.enabled) {
                <!-- Edit Parameter Modifier Trigger Tool Button -->
                <button type="button"
                  class="btn btn-sm btn-icon btn-outline-secondary text-body shadow-sm transition-base d-inline-flex align-items-center justify-content-center"
                  data-bs-toggle="modal" data-bs-target="#updateData" (click)="GetSingleView(data.name)"
                  title="Edit Parameters">
                  <i class="fa-solid fa-pencil font-xs text-body"></i>
                </button>

                <!-- Visibility Rule Allocation State Unlock Trigger Button -->
                <button type="button"
                  class="btn btn-sm btn-icon btn-success shadow-sm transition-base d-inline-flex align-items-center justify-content-center ms-1"
                  (click)="redeemEnableDisable('enabled', data.name)" title="Enable item">
                  <i class="fa-solid fa-check font-xs"></i>
                </button>
                }

                @if (data.enabled) {
                <!-- Visibility Rule Allocation State Block Trigger Button -->
                <button type="button"
                  class="btn btn-sm btn-icon btn-danger shadow-sm transition-base d-inline-flex align-items-center justify-content-center"
                  (click)="redeemEnableDisable('disabled', data.name)" title="Disable Item">
                  <i class="fa-solid fa-ban font-xs"></i>
                </button>
                }
              </div>
              }
            </td>
          </tr>
          } @empty {
          <!-- Empty Data State Placeholder Screen window fallback -->
          <tr>
            <td colspan="9" class="text-center py-5 text-body-secondary">
              <div class="d-flex flex-column align-items-center justify-content-center w-100 text-center">
                <i class="fa-regular fa-folder-open display-6 mb-3 opacity-50"></i>
                <span class="tracking-wider">No Redeemable items records found.</span>
              </div>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>
  </div>

  <!-- Pagination Layout Anchor -->
  <div class="d-flex justify-content-center mt-3">
    <pagination-controls [maxSize]="10" previousLabel="&laquo;" nextLabel="&raquo;" [responsive]="true"
      class="dashboard-pagination" (pageChange)="handlePageChange($event)">
    </pagination-controls>
  </div>

  <!-- Floating Mini Card Indicator -->
  @if (loading()) {
  <div
    class="position-fixed bottom-0 end-0 m-2 z-3 p-3 bg-body card border-info border-opacity-25 shadow-sm d-flex flex-row align-items-center gap-2"
    style="backdrop-filter: blur(4px)">
    <!-- Mini Spinner -->
    <div class="spinner-border text-info" style="width: 1rem; height: 1rem; border-width: 2px" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>

    <!-- Text Badge Layout (Uses your global micro utilities) -->
    <div class="font-monospace text-info fw-bold tracking-widest text-uppercase pe-1 font-xs">Loading...</div>
  </div>
  }
</div>

<!-- ========================================== -->
<!-- ADD NEW REDEEM ITEM MODAL                  -->
<!-- ========================================== -->
<div class="modal fade" id="addNew" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content shadow-lg border-0 bg-body">
      <!-- Modal Header -->
      <div class="modal-header border-bottom px-4 py-3">
        <h5 class="modal-title fw-bold text-gradient-primary">
          <i class="fa-solid fa-circle-plus me-2"></i>Add New Redeem Item
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body px-4 py-4">
        <form [formGroup]="newDataForm" (ngSubmit)="addNewRedeem()" class="d-flex flex-column gap-3">
          <!-- Name Field -->
          <div class="row align-items-start g-2">
            <div class="col-12 col-md-4">
              <label class="form-label small fw-bold text-body-secondary mb-0 mt-md-1.5">Name</label>
              <span class="text-danger-emphasis d-block font-xxs mt-0.5 fw-medium">* Must be unique, cannot update after
                submit</span>
            </div>
            <div class="col-12 col-md-8">
              <input type="text" class="form-control shadow-sm" placeholder="Enter value" formControlName="name" />
            </div>
          </div>

          <!-- Points Field -->
          <div class="row align-items-center g-2">
            <div class="col-12 col-md-4">
              <label class="form-label small fw-bold text-body-secondary mb-0">Points</label>
            </div>
            <div class="col-12 col-md-8">
              <input type="text" class="form-control shadow-sm font-monospace" placeholder="Enter value"
                formControlName="points" />
            </div>
          </div>

          <!-- MMK Value Field -->
          <div class="row align-items-center g-2">
            <div class="col-12 col-md-4">
              <label class="form-label small fw-bold text-body-secondary mb-0">MMK Value</label>
            </div>
            <div class="col-12 col-md-8">
              <input type="text" class="form-control shadow-sm font-monospace" placeholder="Enter value"
                formControlName="mmkValue" />
            </div>
          </div>

          <!-- Service Name Field -->
          <div class="row align-items-center g-2">
            <div class="col-12 col-md-4">
              <label class="form-label small fw-bold text-body-secondary mb-0">Service Name</label>
            </div>
            <div class="col-12 col-md-8">
              <input type="text" class="form-control shadow-sm" placeholder="Enter value"
                formControlName="serviceName" />
            </div>
          </div>

          <!-- Minutes Value Field -->
          <div class="row align-items-center g-2">
            <div class="col-12 col-md-4">
              <label class="form-label small fw-bold text-body-secondary mb-0">Minutes Value</label>
            </div>
            <div class="col-12 col-md-8">
              <input type="text" class="form-control shadow-sm font-monospace" placeholder="Enter value"
                formControlName="minutesValue" />
            </div>
          </div>

          <!-- Redeemable Type Select Field -->
          <div class="row align-items-start g-2">
            <div class="col-12 col-md-4">
              <label class="form-label small fw-bold text-body-secondary mb-0 mt-md-1.5">Redeemable Type</label>
              <span class="text-danger-emphasis d-block font-xxs mt-0.5 fw-medium">* Cannot update after submit</span>
            </div>
            <div class="col-12 col-md-8">
              <select formControlName="redeemableType" class="form-select shadow-sm small">
                <option value="" disabled selected>Choose redeem type</option>
                @for (option of itemTypes; track option) {
                <option [value]="option">{{ option?.replace('_', ' ') }}</option>
                }
              </select>
            </div>
          </div>

          <!-- Submit Button Action Row -->
          <div class="row g-2 mt-2">
            <div class="col-12 col-md-4"></div>
            <div class="col-12 col-md-8">
              <button type="submit"
                class="btn btn-sm btn-primary px-4 py-2 shadow-sm w-100 fw-bold d-inline-flex align-items-center justify-content-center gap-2 micro-action-btn"
                [disabled]="!newDataForm.valid || apiLoading()">
                @if (apiLoading()) {
                <span class="spinner-border micro-spinner" role="status" aria-hidden="true"></span>
                <span>Submitting...</span>
                } @else {
                <span>Submit <i class="fa-solid fa-cloud-arrow-up font-xs"></i></span>
                }
              </button>
            </div>
          </div>
        </form>
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer border-top px-4 py-2.5">
        <button type="button" class="btn btn-sm btn-warning shadow-sm px-3 py-1.5 fw-medium" data-bs-dismiss="modal">
          Close
        </button>
      </div>
    </div>
  </div>
</div>

<!-- ========================================== -->
<!-- UPDATE REDEEM ITEM MODAL                   -->
<!-- ========================================== -->
<div class="modal fade" id="updateData" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content shadow-lg border-0 bg-body">
      <!-- Modal Header -->
      <div class="modal-header border-bottom px-4 py-3">
        <h5 class="modal-title fw-bold text-gradient-primary">
          <i class="fa-solid fa-pen-to-square me-2"></i>Modify Package Specifications
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body px-4 py-4">
        <form [formGroup]="updateDataForm" (ngSubmit)="updateRedeem()" class="d-flex flex-column gap-3">
          <!-- Locked Profile Entity Name Row Element -->
          <div class="row align-items-center g-2 border-bottom pb-2">
            <div class="col-4 small fw-bold text-body-secondary">Item Name</div>
            <div class="col-8 font-monospace fw-bold text-primary-emphasis fs-5">{{ selectedName }}</div>
          </div>

          <!-- Points Field -->
          <div class="row align-items-center g-2">
            <div class="col-12 col-md-4">
              <label class="form-label small fw-bold text-body-secondary mb-0">Points</label>
            </div>
            <div class="col-12 col-md-8">
              <input type="text" class="form-control shadow-sm font-monospace" placeholder="Enter value"
                formControlName="points" />
            </div>
          </div>

          <!-- MMK Value Field -->
          <div class="row align-items-center g-2">
            <div class="col-12 col-md-4">
              <label class="form-label small fw-bold text-body-secondary mb-0">MMK value</label>
            </div>
            <div class="col-12 col-md-8">
              <input type="text" class="form-control shadow-sm font-monospace" placeholder="Enter value"
                formControlName="mmkValue" />
            </div>
          </div>

          <!-- Service Name Field -->
          <div class="row align-items-center g-2">
            <div class="col-12 col-md-4">
              <label class="form-label small fw-bold text-body-secondary mb-0">Service</label>
            </div>
            <div class="col-12 col-md-8">
              <input type="text" class="form-control shadow-sm" placeholder="Enter value"
                formControlName="serviceName" />
            </div>
          </div>

          <!-- Minute Value Field -->
          <div class="row align-items-center g-2">
            <div class="col-12 col-md-4">
              <label class="form-label small fw-bold text-body-secondary mb-0">Minute</label>
            </div>
            <div class="col-12 col-md-8">
              <input type="text" class="form-control shadow-sm font-monospace" placeholder="Enter value"
                formControlName="minutesValue" />
            </div>
          </div>

          <!-- Submit Button Action Row -->
          <div class="row g-2 mt-2">
            <div class="col-12 col-md-4"></div>
            <div class="col-12 col-md-8">
              <button type="submit"
                class="btn btn-sm btn-primary px-4 py-2 shadow-sm w-100 fw-bold d-inline-flex align-items-center justify-content-center gap-2 micro-action-btn"
                [disabled]="!updateDataForm.valid || apiLoading()">
                @if (apiLoading()) {
                <span class="spinner-border micro-spinner" role="status" aria-hidden="true"></span>
                <span>Updating Changes...</span>
                } @else {
                <span>Submit <i class="fa-solid fa-floppy-disk font-xs"></i></span>
                }
              </button>
            </div>
          </div>
        </form>
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer border-top px-4 py-2.5">
        <button type="button" class="btn btn-sm btn-warning shadow-sm px-3 py-1.5 fw-medium" data-bs-dismiss="modal">
          Close
        </button>
      </div>
    </div>
  </div>
</div>